import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {CardOrder} from '../../CardOrder';
import {
  NgbCalendar,
  NgbDate,
  NgbInputDatepicker,
  NgbModal,
  NgbPagination
} from '@ng-bootstrap/ng-bootstrap';
import {EntitlementService} from '../../services/entitlement.service';
import {Router} from '@angular/router';
import {MessageService} from '../../services/message.service';
import {SystemService} from '../../services/system.service';
import {DatePipe, NgForOf, NgIf, SlicePipe} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-card-order',
  standalone: true,
  imports: [
    DatePipe,
    FormsModule,
    NgForOf,
    NgIf,
    NgbInputDatepicker,
    NgbPagination,
    SlicePipe,
    ReactiveFormsModule
  ],
  templateUrl: './card-order.component.html',
  styleUrl: './card-order.component.css'
})
export class CardOrderComponent   implements  OnInit {
  @Output() registerCancel = new EventEmitter();
  newShipForm: UntypedFormGroup;
  cardOrders: CardOrder[];
  page = 1;
  startDate: NgbDate;
  endDate: NgbDate;
  spinner = false;
  pageSize = 25;
  dateChanged = false;

  constructor(
    private calendar: NgbCalendar,
    private entitlementService: EntitlementService,
    private systemService: SystemService,
    private toastrService: ToastrService,
  ) {}
  ngOnInit() {
    this.initForm();
    this.endDate = this.calendar.getToday();
    this.startDate = this.calendar.getPrev(this.endDate, 'd', 90);
    this.getCardOrderDetails();
  }

  getCardOrderDetails(){
    this.dateChanged = true;
    this.spinner = true;
    const startDateString =
      this.startDate.month +
      '/' +
      this.startDate.day +
      '/' +
      this.startDate.year;
    const endDateString =
      this.endDate.month + '/' + this.endDate.day + '/' + this.endDate.year;


    this.validDates(startDateString, 'Start Date');
    if (this.dateChanged) {  this.validDates(endDateString, 'End Date'); }
    if (this.dateChanged) {
      this.systemService.getCardOrders(startDateString, endDateString).subscribe(
        (data) => {
          this.cardOrders = data;
          this.cardOrders.sort((objA, objB) =>
            new Date(objB.requestDate).getTime() - new Date(objA.requestDate).getTime());
          this.spinner = false;
        },
        (error) => {
          console.log('Error getting all pending ships: ' + error);
          this.spinner = false;
          this.toastrService.error('Had an issue finding reports.');
        },
        () => {
        }
      );
    }else {
      this.spinner = false;
    }
  }

  changeDate() {
    this.dateChanged = true;
    this.getCardOrderDetails();
  }

  validDates(strDate: string, label: string) {
    const validFormat = /\d{1,2}\/\d{1,2}\/\d{4}/.test(strDate);
    if (!validFormat) {
      this.dateChanged = false;
      this.toastrService.error('Invalid ' +  label);
    }
  }


  initForm() {
    this.newShipForm = new UntypedFormGroup({
      locationType: new UntypedFormControl('')
    });
  }
  hasEntitlement(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }
}
